import {
    FavouriteLockerType, LocalStorageFavouriteLocker, PostMessage,
    PreviouslyUsedLocker, SubscriptionType
} from '../data/LockerDataTypes';
import { useTranslation } from 'react-i18next';
import { useSpecificLockerActionContext } from '../contexts/SpecificLockerActionContext';
import { has3rdPartyCookiesEnabled } from '../utils/ThirdPartyCookies';
import { FAV_LOCKER_KEY, PRV_USED_LOCKERS_KEY } from '../Settings';

export class LockerService {
    public static isAnyLockerSelected = (): boolean => {
        const { selectedLocker } = useSpecificLockerActionContext();
        if (selectedLocker?.name && selectedLocker?.lockerId) {
            return true;
        }
        return false;
    }

    public static getPostMessage = (type: SubscriptionType, objectToPush: any): PostMessage => {
        return {
            subscription: type,
            object: objectToPush
        };
    }
}

export const removeEasyboxFromLockername = (lockerName: string): string => {
    return lockerName.replace(/easybox/gi, "");
}

export const getDayName = (dayNumber: number): string => {
    const { t } = useTranslation();
    switch (dayNumber) {
        case 1: return t("monday");
        case 2: return t("tuesday");
        case 3: return t("wednesday");
        case 4: return t("thursday");
        case 5: return t("friday");
        case 6: return t("saturday");
        case 7: return t("sunday");
        default: return "";
    }
}

export const classNames = (...classes: any) => {
    return classes.filter(Boolean).join(' ');
};

export const getFavouriteLockers = (countryCode: string): LocalStorageFavouriteLocker[] => {
    if (!has3rdPartyCookiesEnabled()) { return [] as LocalStorageFavouriteLocker[]; }
    try {
        let favouriteLockers: LocalStorageFavouriteLocker[] = [];

        const itemKey = FAV_LOCKER_KEY!.concat(countryCode);
        const serializedItem = localStorage.getItem(itemKey) || '[]';
        let result = (JSON.parse(serializedItem) as LocalStorageFavouriteLocker[]).filter(x=> x != null);

        if (Array.isArray(result)) {
            favouriteLockers = result;
        }
        else if (!isObjectNullOrEmpty(result)) {
            favouriteLockers.push(result);
            favouriteLockers[0].type = FavouriteLockerType.Home;
        }

        return favouriteLockers;
    }
    catch {
        return [] as LocalStorageFavouriteLocker[]; 
    }
}

export const saveUsedLockersToLocalStorage = (countryCode: string,
    previouslyUsedLockers: PreviouslyUsedLocker[]): void => {
    if (has3rdPartyCookiesEnabled()) {
        const key = PRV_USED_LOCKERS_KEY.concat(countryCode);
        localStorage.setItem(key, JSON.stringify(previouslyUsedLockers));
    }
}

interface PreviouslyUsedLockerInStorage extends Omit<PreviouslyUsedLocker, 'dateClicked'> {
    dateClicked: string;
}

export const getPreviouslyUsedLockers = (countryCode: string): PreviouslyUsedLocker[] => {
    try {
        if (has3rdPartyCookiesEnabled()) {
            const key = PRV_USED_LOCKERS_KEY.concat(countryCode);
            const items = (JSON.parse(localStorage.getItem(key) || '[]') as PreviouslyUsedLockerInStorage[]).filter(x => x != null);
            const convToDate = (strDate: string): Date => strDate && strDate.length > 0 ? new Date(strDate) : new Date;
            
            const lockers = items.map((item): PreviouslyUsedLocker => {
                return {
                    lockerId: item.lockerId,
                    lat: item.lat,
                    lng: item.lng,
                    dateClicked: convToDate(item.dateClicked),
                }
            });
            return lockers;
        }

        return [] as PreviouslyUsedLocker[];
    }
    catch {
        return [] as PreviouslyUsedLocker[];
    }
}



export const isObjectNullOrEmpty = (objectParam: any): boolean => {
    return !objectParam || Object.keys(objectParam).length < 1
}